module.exports = __webpack_public_path__ + "6d8d6e13c89c32e781cfb6a2864339f0.MP3";